import type { ReactNode } from 'react';

// Two-column step body: primary content left, preview graphic right. Shared so the preview renders
// consistently across in-progress and complete states.
export function StepWithPreview({
  children,
  preview,
}: {
  children: ReactNode;
  preview: ReactNode;
}) {
  return (
    <div className="flex flex-row flex-nowrap items-center justify-between gap-4">
      <div className="flex max-w-lg flex-col gap-3">{children}</div>
      <div className="shrink-0">{preview}</div>
    </div>
  );
}
